"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopConfig = void 0;
class ShopConfig {
    static getAppEnv() {
        return this.config.env.APP_ENV;
    }
    static hasAppEnv() {
        return this.config.hasOwnProperty('env') && this.config['env'].hasOwnProperty('APP_ENV');
    }
    static getLocale() {
        return this.config.env.LOCALE;
    }
    static hasLocale() {
        return this.config.hasOwnProperty('env') && this.config['env'].hasOwnProperty('LOCALE');
    }
    static getShopLocation2IsoCode() {
        if (!this.hasLocale()) {
            return 'HU';
        }
        let locale = this.getLocale();
        return locale.slice(-2);
    }
    static getShopLocation() {
        return this.config.env.SHOP_LOCATION;
    }
    static hasShopLocation() {
        return this.config.hasOwnProperty('env') && this.config['env'].hasOwnProperty('SHOP_LOCATION');
    }
    static getTranslations() {
        return this.config.translations;
    }
    static hasTranslations() {
        return this.config.hasOwnProperty('translations');
    }
    static getAlcarSearchHost() {
        if ('' !== this.config.env.ALCAR_SEARCH_HOST) {
            return this.config.env.ALCAR_SEARCH_HOST;
        }
        return 'https://kiskershop.localhost';
    }
    static getAxaptaPopupHost() {
        if ('' !== this.config.env.AXAPTA_POPUP_HOST) {
            return this.config.env.AXAPTA_POPUP_HOST;
        }
        return 'https://kiskershop.localhost';
    }
    static getLocationApiConnection() {
        return {
            url: this.config.env.LOCATION_API_URL,
            token: this.config.env.LOCATION_API_TOKEN,
        };
    }
    static getDeliveryManagerApiUrl() {
        if (!this.config.env.DELIVERY_MANAGER_URL || this.config.env.DELIVERY_MANAGER_URL === '') {
            throw new Error('Delivery manager URL is not configured!');
        }
        return this.config.env.DELIVERY_MANAGER_URL + '/api';
    }
    static getCashPaymentModeDisabledLimits() {
        return this.config.cashPaymentModeDisabledLimits;
    }
    static getGoogleTrackingId() {
        return this.config.googleTrackingId;
    }
    static getClarityTrackingId() {
        return this.config.clarityTrackingId;
    }
    static getCompanyData() {
        return this.config.companyData;
    }
    static getPairSearchConfig() {
        return this.config.pairSearch || { enabled: false, types: {} };
    }
    static isPairSearchEnabled() {
        var _a;
        return ((_a = this.config.pairSearch) === null || _a === void 0 ? void 0 : _a.enabled) || false;
    }
    static isPairSearchEnabledForType(type) {
        var _a, _b, _c;
        if (!this.isPairSearchEnabled()) {
            return false;
        }
        if (Array.isArray(type)) {
            return type.every(t => this.isPairSearchEnabledForType(t));
        }
        if ((_c = (_b = (_a = this.config.pairSearch) === null || _a === void 0 ? void 0 : _a.types) === null || _b === void 0 ? void 0 : _b[type]) === null || _c === void 0 ? void 0 : _c.enabled) {
            return true;
        }
        if (type.includes('And')) {
            const parts = type.split('And').map(part => {
                return part.charAt(0).toLowerCase() + part.slice(1);
            });
            return parts.some(part => { var _a, _b, _c; return ((_c = (_b = (_a = this.config.pairSearch) === null || _a === void 0 ? void 0 : _a.types) === null || _b === void 0 ? void 0 : _b[part]) === null || _c === void 0 ? void 0 : _c.enabled) || false; });
        }
        return false;
    }
    static shouldShowPairSearchForType(type) {
        if (!this.isPairSearchEnabled()) {
            return false;
        }
        return this.isPairSearchEnabledForType(type);
    }
    static getTags() {
        return this.config.tags || {};
    }
    static getTagsByType(type) {
        const tags = this.getTags();
        return tags[type];
    }
    static getDepartments() {
        return this.config.departments || [];
    }
    static getCustomerGroups() {
        return this.config.customerGroups || [];
    }
}
/* @ts-ignore */
ShopConfig.config = window.shopConfig;
exports.ShopConfig = ShopConfig;
